import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";
import ActionButton from "../ui/ActionButton";

// shown when no approved pickups exist at all
function ScheduleEmptyState() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="schedule-empty-state">
      <div className="schedule-empty-state__icon">
        <FontAwesomeIcon icon={faBoxOpen} />
      </div>
      <h3 className="schedule-empty-state__title">
        {t("schedule.emptyState.title", "No pickups yet")}
      </h3>
      <p className="schedule-empty-state__desc">
        {t(
          "schedule.emptyState.description",
          "Approved pickup requests will appear here. Browse the marketplace to find materials and submit requests."
        )}
      </p>
      <div className="schedule-empty-state__actions">
        <ActionButton
          variant="primary"
          onClick={() => navigate("/receiver/marketplace")}
        >
          {t("schedule.emptyState.cta", "Browse marketplace")}
        </ActionButton>
      </div>
    </div>
  );
}

export default ScheduleEmptyState;
